// extracted by mini-css-extract-plugin
export var around = "Spanlink-module--around--4f354";
export var between = "Spanlink-module--between--6918f";
export var button = "Spanlink-module--button--e943c";
export var buttonSpans = "Spanlink-module--button-spans--584d3";
export var hoverBetween = "Spanlink-module--hover-between--fba50";
export var hoverEnd = "Spanlink-module--hover-end--62298";
export var hoverStart = "Spanlink-module--hover-start--62aa1";
export var spanlink = "Spanlink-module--spanlink--de78a";
export var uppercase = "Spanlink-module--uppercase--7ced4";